import PropTypes from 'prop-types';

import { photoFormPropTypes } from 'components/photos/photo_form';

export const LeaseMediaLinksPropTypes = PropTypes.shape({
  floorPlan: PropTypes.shape({
    id: PropTypes.number,
    uploadId: PropTypes.number,
    thumbnailUrl: PropTypes.string
  }),
  matterportUrl: PropTypes.string,
  videoUrl: PropTypes.string,
  virtualTourUrl: PropTypes.string
});

export const LeaseSpacesMediaPropTypes = PropTypes.oneOfType([
  PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      visualMediaEmbeds: PropTypes.array,
      visualMediaEmbedsForCustomer: PropTypes.array,
      photoProps: PropTypes.shape({
        ...photoFormPropTypes
      }),
      ...LeaseMediaLinksPropTypes
    })
  ),
  PropTypes.array
]);

export const MediaPropTypes = PropTypes.shape({
  leaseSpacesMedia: LeaseSpacesMediaPropTypes,
  maprightEmbedCode: PropTypes.string,
  matterportUrl: PropTypes.string,
  ovalroomGroupAdmin: PropTypes.bool,
  photoProps: PropTypes.shape({
    ...photoFormPropTypes
  }),
  realvisionUrl: PropTypes.string,
  terrastrideEmbedCode: PropTypes.string,
  visualMediaEmbeds: PropTypes.array,
  visualMediaEmbedsForCustomer: PropTypes.array,
  visualMediaTypeOptions: PropTypes.array,
  youTubeUrl: PropTypes.string
});
